// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2JfBa","name":"ConsentHeader_name__1ls4r","birthday":"ConsentHeader_birthday__1RBx_","skeleton":"ConsentHeader_skeleton__25gNh"};